import * as React from "react"
import { Typography } from '@mui/material'


export default function brandColumn() {
return {
		name: 'Marca',
		label: 'Marca',
		options: {
			customBodyRowRenderLite: value => <Typography sx={{ textAlign: 'center' }}>
				{value || '-'}
			</Typography>
		}
	}
}